export default __webpack_public_path__ + "static/media/stage_cancelled.de08ac70.svg";